import { Services } from "appworks/services/services";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";
import { ButtonControl } from "./button-control";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";

export class AutoplayControl extends ButtonControl {
    public setEnabled(enabled: boolean) {
        const juriAllowsAutoplay = Services.get(JurisdictionService).getAutoplayEnabled();

        if (!juriAllowsAutoplay) {
            super.setEnabled(false);
            this.button.setVisible(false);
        } else {
            const isInProgress = uiFlags.has(UIFlag.BIG_WIN_DELAY) || uiFlags.has(UIFlag.BIG_WIN) || uiFlags.has(UIFlag.GAME_IN_PROGRESS);
            const shouldEnableButton = enabled && (uiFlags.has(UIFlag.IDLE) || !isInProgress);
            super.setEnabled(shouldEnableButton);
        }
    }
}
